<template>
  <div class="container">
    <div class="row mt-5">
      <div class="col-md-5">
        <input
          name="password"
          id="password"
          type="password"
          class="form-control"
          v-model="password"
          @keyup.enter="sendPassword"
        />
      </div>
      <div class="">
        <button class="btn btn-success btn-block" @click.prevent="sendPassword">
          Submit
        </button>
      </div>
    </div>
    {{ showencode }}
  </div>
</template>
<script>
export default {
  mounted() {},
  data() {
    return {
      filename: null,
      file: null,
      password: null,
      showencode: null,
    };
  },
  methods: {
    sendPassword() {
      axios
        .post("/api/staff/genhash", {
          password: this.password,
        })
        .then((response) => {
          this.showencode = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    imagePreview(event) {
      let selectedFile = event.target.files[0];
      this.file = selectedFile;
    },

    uploadImage2() {
      let formData = new FormData();
      formData.append("image", this.file);
      axios
        .post("/api/members/uploadpimg", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          flash(response.data.message, "success");
        })
        .catch((e) => {
          console.log(e);
        });
    },

    onImageChange(e) {
      //console.log(e.target.files[0]);
      this.filename = "Selected File: " + e.target.files[0].name;
      this.file = e.target.files[0];
    },
    uploadImage() {
      let currentObj = this;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };

      // form data
      let formData = new FormData();
      formData.append("file-img", this.file);

      // send upload request
      axios
        .post("/api/members/uploadpimg", formData, config)
        .then(function(response) {
          currentObj.success = response.data.success;
          currentObj.filename = "";
        })
        .catch(function(error) {
          currentObj.output = error;
        });
    },
  },
};
</script>
